export const alertConstants = {
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  CLEAR: "ALERT_CLEAR",
  UPDATE_FULL_ALERT_STATE: "UPDATE_FULL_ALERT_STATE",
};
